import React from 'react';
import { FiTruck, FiRefreshCcw, FiShield } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const ShippingReturns = () => {
  return (
    <section className="py-16 bg-signal text-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-8 divide-y md:divide-y-0 md:divide-x divide-white/20">
          
          <div className="flex flex-col items-center text-center p-4">
            <SafeIcon icon={FiTruck} className="text-4xl mb-4" />
            <h3 className="text-xl font-black uppercase tracking-wide mb-2">Free Fast Shipping</h3>
            <p className="text-white/80 text-sm">On all orders over $75. Gets to your door in 2-4 business days.</p>
          </div>

          <div className="flex flex-col items-center text-center p-4">
            <SafeIcon icon={FiRefreshCcw} className="text-4xl mb-4" />
            <h3 className="text-xl font-black uppercase tracking-wide mb-2">30-Day Test Ride</h3>
            <p className="text-white/80 text-sm">Don't love it? Return it within 30 days for a full refund. No sweat.</p>
          </div>

          <div className="flex flex-col items-center text-center p-4">
            <SafeIcon icon={FiShield} className="text-4xl mb-4" />
            <h3 className="text-xl font-black uppercase tracking-wide mb-2">Lifetime Warranty</h3>
            <p className="text-white/80 text-sm">Our hard goods are guaranteed against manufacturing defects for life.</p>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ShippingReturns;